import React from 'react';
import styles from './addtobasket.module.css';
import { ButtonsBlock, buttonLinkStyles, buttonOrangeStyles, buttonExampleStyles } from './AddToBasket.styles';
import { Box } from '@mui/material';
import { LoaderIcon as Loader } from '../../../../Icons/'

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export function AddToBasket(props: { text:string; isLoading:boolean;handleMakePDF:any}) { //TODO: FIX ANY!!!!
    const domContainer = document.querySelector('#constructor_app');
    const whatsappLink = domContainer?.getAttribute('data-whatsapp-link');

    return (
        <ButtonsBlock>
            <Box
                onClick={() => {
                    props.handleMakePDF(true);
                }}
                className={`${styles.buyLink} ${styles.downloadPDFLink}`} sx={buttonExampleStyles}>
                Скачать PDF
            </Box>

            <Box
                onClick={() => {
                    if(props.text === 'Добавить в корзину') return;
                    window.location.href = '/cart/';
                }}
                id={'addToBasketButton'} className={`${styles.buyLink}`} sx={buttonOrangeStyles}>
                {!props.isLoading ? props.text : <Loader className={`${styles.spinner}`} />}
                {/*<ArrowForwardIosIcon/>*/}
            </Box>

            <Box
                onClick={() => {
                    window.open('https://wa.me/79258721817/?text=Здравствуйте, необходим выезд менеджера с каталогами на объект. Свяжитесь со мной, пожалуйста.', '_blank');
                }}
                className={`${styles.buyLink} ${styles.downloadPDFLink}`} sx={buttonExampleStyles}>
                {'Заказать выезд менеджера'}
            </Box>

            {/*<Box component="a" className={`${styles.link}`} href={`${whatsappLink}`} target="_blank"*/}
            {/*     rel="noreferrer" sx={buttonLinkStyles}>*/}
            {/*    <svg className={styles.whatsapp} width="700" height="725" viewBox="0 0 700 725" fill="none"*/}
            {/*         xmlns="http://www.w3.org/2000/svg">*/}
            {/*        <path fillRule="evenodd" clipRule="evenodd"*/}
            {/*              d="M350 725C543.3 725 700 568.3 700 375C700 181.7 543.3 25 350 25C156.7 25 0 181.7 0 375C0 437.773 16.525 496.685 45.4618 547.625L0 725L182.872 682.595C232.535 709.635 289.473 725 350 725ZM350 671.155C513.563 671.155 646.155 538.563 646.155 375C646.155 211.44 513.563 78.8463 350 78.8463C186.439 78.8463 53.8463 211.44 53.8463 375C53.8463 438.152 73.6125 496.687 107.296 544.755L80.7693 644.23L181.998 618.923C229.735 651.865 287.615 671.155 350 671.155Z"*/}
            {/*              fill="#BFC8D0"/>*/}
            {/*        <path*/}
            {/*            d="M650 350C650 515.685 515.685 650 350 650C286.805 650 228.173 630.46 179.817 597.092L77.2727 622.727L104.144 521.96C70.023 473.268 50 413.973 50 350C50 184.315 184.315 50 350 50C515.685 50 650 184.315 650 350Z"*/}
            {/*            fill="url(#paint0_linear_2_7)"/>*/}
            {/*        <path fillRule="evenodd" clipRule="evenodd"*/}
            {/*              d="M350 700C543.3 700 700 543.3 700 350C700 156.7 543.3 0 350 0C156.7 0 0 156.7 0 350C0 412.773 16.525 471.685 45.4618 522.625L0 700L182.872 657.595C232.535 684.635 289.473 700 350 700ZM350 646.155C513.563 646.155 646.155 513.563 646.155 350C646.155 186.439 513.563 53.8463 350 53.8463C186.439 53.8463 53.8463 186.439 53.8463 350C53.8463 413.152 73.6125 471.687 107.296 519.755L80.7693 619.23L181.998 593.923C229.735 626.865 287.615 646.155 350 646.155Z"*/}
            {/*              fill="white"/>*/}
            {/*        <path*/}
            {/*            d="M262.5 187.497C254.18 170.783 241.413 172.263 228.518 172.263C205.47 172.263 169.531 199.87 169.531 251.25C169.531 293.358 188.086 339.45 250.61 408.402C310.95 474.947 390.235 509.37 456.055 508.198C521.875 507.028 535.418 450.385 535.418 431.257C535.418 422.78 530.155 418.55 526.533 417.4C504.103 406.635 462.732 386.578 453.32 382.81C443.907 379.043 438.992 384.14 435.938 386.912C427.403 395.045 410.483 419.02 404.688 424.412C398.895 429.805 390.257 427.075 386.662 425.037C373.435 419.73 337.572 403.778 308.987 376.065C273.632 341.795 271.557 330.003 264.897 319.508C259.57 311.11 263.48 305.96 265.43 303.708C273.047 294.92 283.565 281.35 288.282 274.608C292.997 267.863 289.255 257.625 287.007 251.25C277.345 223.825 269.157 200.868 262.5 187.497Z"*/}
            {/*            fill="white"/>*/}
            {/*        <defs>*/}
            {/*            <linearGradient id="paint0_linear_2_7" x1="612.5" y1="125" x2="50" y2="650"*/}
            {/*                            gradientUnits="userSpaceOnUse">*/}
            {/*                <stop stopColor="#5BD066"/>*/}
            {/*                <stop offset="1" stopColor="#27B43E"/>*/}
            {/*            </linearGradient>*/}
            {/*        </defs>*/}
            {/*    </svg>*/}
            {/*    Заказать в WhatsApp*/}
            {/*    <ArrowForwardIosIcon/>*/}
            {/*</Box>*/}
        </ButtonsBlock>
    );
}



